import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const SweetAlert = withReactContent(Swal);

interface AlertOptions {
    title?: string;
    text?: string;
    icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
    confirmButtonText?: string;
    timer?: number;
}

const showAlert = ({
    title = 'Alert',
    text = '',
    icon = 'info',
    confirmButtonText = 'OK',
    timer,
}: AlertOptions) => {
    return SweetAlert.fire({
        title,
        text,
        icon,
        confirmButtonText,
        timer,
    });
};

export default showAlert;
